import { range } from "../range";

export const years = range(1900, (new Date()).getUTCFullYear())
    .sort((a, b) => b - a)
    .map((value) => value.toString());
